<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2 text-center">
      <h2 class="mb-2 text-center">Verify Code</h2>
      You should receive a 6-digit code.  Enter it below to verify this device.
    </div>
    <v-form ref="form" @submit.prevent="verifyClick">
      <v-otp-input 
        length="6" class="mb-4"
        type="number"
        v-model="verification_code"
        :rules="[required, valid_code]"
        tabindex="1"
      />

      <div class="ml-3 mt-n1 mb-5">
        Didn't receive your code?
        <a style="text-decoration: underline;" @click.stop="resendCode">Request again.</a>
      </div>
      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Verify Device</v-btn>
      </div>
    </v-form>

    <div class="ml-3 mt-3 text-center">
      <a style="text-decoration: underline;" @click.stop="$router.back()">Do it Later</a>
    </div>

    <ErrorOverlay
      title="Verfication Error" 
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </div>
</template>

<script>
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'
import { mapActions } from 'vuex'
import { required, valid_code } from '@/lib/validations'

export default {
  name: 'ProfileCellWizardVerify',

  mixins: [ ErrorOverlayMixin ],

  props: ['device_id'],

  data: () => ({
    loading: false,
    phone: '',
    verification_code: '',

    // validation rules
    required,
    valid_code,
  }),

  methods: {
    ...mapActions('devices', ['createDevice', 'resend_code', 'verify']),

    async resendCode() {
      const { device_id } = this

      this.loading = true
      const result = await this.resend_code({ device_id })
      this.loading = false

      if (!result.ok) {
        this.error_dialog = true
        this.error_message = result.error
      }
    },

    async verifyClick() {
      if (this.$refs.form.validate()) {
        const { device_id, verification_code } = this

        this.loading = true
        const result = await this.verify({ device_id, verification_code })
        this.loading = false

        if (result.ok) {
          this.$router.replace( { name: 'profile/wizard/congrats' } )
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>